// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Bookings-info-box[data-v-4d469c72]{padding:20px;background-color:#eeeab1}.Bookings-wrapper[data-v-4d469c72]{display:flex;flex-wrap:wrap;gap:10px}.Bookings-booking-item[data-v-4d469c72]{padding:10px}@media only screen and (max-width:1000px){.Bookings-booking-item[data-v-4d469c72]{padding:10px;margin:30px;width:calc(100% - 80px)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
